import React from 'react';
import styles from './MembershipStatusBadge.module.css';

const MembershipStatusBadge = ({ status, isFollowing, followedAt, type = 'membership' }) => {
  // Handle following badge
  if (type === 'following' && isFollowing) {
    return (
      <span className={`${styles.badge} ${styles.following}`}>
        <span className={styles.icon}>👀</span>
        <span className={styles.text}>
          Following{followedAt && ` since ${new Date(followedAt).toLocaleDateString()}`}
        </span>
      </span>
    );
  }

  // Handle membership status badge
  if (!status) return null;

  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'enrolled':
        return {
          text: 'Enrolled',
          className: styles.enrolled,
          icon: '✅'
        };
      case 'suspended':
        return {
          text: 'Suspended',
          className: styles.suspended,
          icon: '⏸️'
        };
      case 'withdrawn':
        return {
          text: 'Withdrawn',
          className: styles.withdrawn,
          icon: '🚫'
        };
      case 'applied':
        return {
          text: 'Applied',
          className: styles.applied,
          icon: '📋'
        };
      case 'waitlisted':
        return {
          text: 'Waitlisted',
          className: styles.waitlisted,
          icon: '⏳'
        };
      case 'following':
        return {
          text: 'Following',
          className: styles.following,
          icon: '👀'
        };
      default:
        return {
          text: status,
          className: styles.default,
          icon: '📌'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`${styles.badge} ${config.className}`}>
      <span className={styles.icon}>{config.icon}</span>
      <span className={styles.text}>{config.text}</span>
    </span>
  );
};

export default MembershipStatusBadge;
